import React, { FC, useState } from 'react';
import { Button, InputText } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteComponentProps } from 'react-router-dom';
import { loginService } from '@agro1desenvolvimento/apis-js-package';
import userService from '../../services/users';
import notifications from '../../services/notifications';
import AuthCard from '../../components/AuthCard';
import PasswordInput from '../../components/PasswordInput';

type PropTypes = RouteComponentProps;

const LoginPage: FC<PropTypes> = ({ history }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const footer = (
    <>
      <div className="p-text-center auth-footer">
        <a href="#/send_email" className="forgot-password">Esqueci minha senha</a>
        <Button
          label="Entrar"
          className="auth-button p-mt-5"
          type="submit"
          form="login-form"
          disabled={loading}
        />

        <div className="p-text-center p-my-5">
          { loading && <FontAwesomeIcon icon="spinner" spin /> }
        </div>
      </div>
    </>
  );

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      setLoading(true);
      loginService.currentUser = await userService.login(login, password);
      history.push('/');
    } catch (error: any) {
      let errorMessage = 'Não foi possível realizar o login';

      if (error.response?.status === 401) errorMessage = 'Usuário e/ou Senha inválidos';

      notifications.error({ message: errorMessage });
      console.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Acesse sua conta" footer={footer}>
      <form onSubmit={handleLogin} id="login-form">
        <div className="p-col-12 auth-field">
          <label htmlFor="login" className="auth-label">
            Email
          </label>
          <div className="auth-input-container">
            <FontAwesomeIcon
              icon="user"
              className="auth-icon"
            />
            <InputText
              id="login"
              autoFocus
              required
              value={login}
              title="Email"
              placeholder="Digite seu email"
              className="auth-input"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLogin(e.target.value)}
            />
          </div>
        </div>

        <PasswordInput
          id="password"
          label="Senha"
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          placeholder="Digite sua senha"
          title="Senha"
          required
        />
      </form>
    </AuthCard>
  );
};

export default LoginPage;
